import React from 'react';

import { Slot } from '@radix-ui/react-slot';
import { tv, type VariantProps } from 'tailwind-variants';

import cn from '../../utils/cn';

export interface LinkProps extends React.ComponentPropsWithoutRef<'a'> {
  asChild?: boolean;
}

const linkVariants = tv({
  base: 'cursor-pointer font-bold text-link underline transition-colors hover:text-primary-dark focus:text-primary-dark focus-visible:text-primary-dark',
  variants: {
    size: {
      sm: 'text-sm',
      md: 'text-md',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export interface LinkProps extends React.ComponentPropsWithoutRef<'a'>, VariantProps<typeof linkVariants> {
  asChild?: boolean;
}

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(({ className, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : 'a';
  return <Comp className={cn(linkVariants({ size, className }))} ref={ref} {...props} />;
});

Link.displayName = 'Link';

export default Link;
